import { CognitoAdapterBase } from "./cognito-adapter-base";
import { ServiceAuthError, type ServiceKey, type TokenSet } from "./types";

/**
 * Adapter base for integrations whose real auth flow has not yet been
 * implemented. Provides the right header shape (standard Bearer) so any
 * passing reference compiles, but throws NotImplemented as soon as a real
 * connection attempt is made. Each integration should replace this with
 * its own adapter when its flow is built.
 */
export abstract class StubBearerAdapter extends CognitoAdapterBase {
  abstract readonly key: ServiceKey;
  abstract readonly category: string;

  getAuthHeaders(): Record<string, string> {
    if (!this.tokens) return {};
    return { Authorization: `Bearer ${this.tokens.idToken}` };
  }

  override silentConnect(): Promise<TokenSet | null> {
    return Promise.resolve(null);
  }

  override connect(): Promise<TokenSet> {
    return Promise.reject(
      new ServiceAuthError(this.key, `${this.key} adapter not yet implemented`),
    );
  }
}
